import { render, staticRenderFns } from "./collage.vue?vue&type=template&id=2f8b9932&scoped=true"
import script from "./collage.vue?vue&type=script&lang=js"
export * from "./collage.vue?vue&type=script&lang=js"
import style0 from "./collage.vue?vue&type=style&index=0&id=2f8b9932&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f8b9932",
  null
  
)

export default component.exports